import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class CertificationDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getCertificationOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('Certifications/Options', request, cancellationToken);
  }

  getCertificationTitleStatesAsync(cancellationToken: Promise<any>): Promise<ListOption<string>[]> {
    return this.httpClient.getJsonAsync<ListOption<string>[]>('CertificationTitles/GetCertificationTitleStates', null, cancellationToken);
  }
}
